import * as React from "react";
import PropTypes from "prop-types";
import Box from "@mui/material/Box";
import Collapse from "@mui/material/Collapse";
import IconButton from "@mui/material/IconButton";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import KeyboardArrowUpIcon from "@mui/icons-material/KeyboardArrowUp";

function Row(props) {
  const { row } = props;
  const [open, setOpen] = React.useState(false);

  return (
    <React.Fragment>
      <TableRow sx={{ "& > *": { borderBottom: "unset" } }}>
        <TableCell>
          <IconButton
            aria-label="expand row"
            size="small"
            onClick={() => setOpen(!open)}
          >
            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
          </IconButton>
        </TableCell>
        <TableCell component="th" scope="row">
          {row.farmerId.farmerCode}
        </TableCell>
        <TableCell component="th" scope="row">
          {row.farmerId.fullName}
        </TableCell>
        <TableCell component="th" scope="row">
          {row.farmerId.workingAreaId.areaName}
        </TableCell>
      </TableRow>
      <TableRow>
        <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={6}>
          <Collapse in={open} timeout="auto" unmountOnExit>
            <Box sx={{ margin: 1 }}>
              <Table size="small" aria-label="purchases">
                <TableHead>
                  <TableRow>
                    <TableCell>Aktifitas</TableCell>
                    <TableCell>Deskripsi</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {row.activities.length > 0 ? (
                    row.activities.map((item, index) => {
                      return (
                        <TableRow key={index}>
                          <TableCell>
                              {item.idActivity ? item.idActivity.activityName : "Data Kosong"}
                          </TableCell>
                          <TableCell>
                              {item.description}
                          </TableCell>
                        </TableRow>
                      );
                    })
                  ) : (
                    <p>Data Kosong</p>
                  )}
                </TableBody>
              </Table>
            </Box>
          </Collapse>
        </TableCell>
      </TableRow>
    </React.Fragment>
  );
}

Row.propTypes = {
  row: PropTypes.object,
  index: PropTypes.number,
};

export default function SpvReportActivityDetailTable({ data }) {
  return (
    <TableContainer component={Paper}>
      <Table aria-label="collapsible table">
        <TableHead style={{ background: "#499178" }}>
          <TableRow style={{ color: "white" }}>
            <TableCell />
            <TableCell style={{ color: "white" }}>Kode</TableCell>
            <TableCell style={{ color: "white" }}>Nama</TableCell>
            <TableCell style={{ color: "white" }}>Area</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.docs.map((row, index) => (
            <Row key={index} row={row} />
          ))}
        </TableBody>
      </Table>
    </TableContainer>
  );
}

SpvReportActivityDetailTable.propTypes = {
  data: PropTypes.array,
};
